import React, { useMemo } from 'react'
import { motion } from 'framer-motion'
import { createColumnHelper } from '@tanstack/react-table'
import { Table } from '@demandlocal/components'
import { Link } from 'react-router-dom'
import { useGetPaginatedCDKDealerships } from '../../../../api/admin/useGetPaginatedCDKDealerships'
import dayjs from 'dayjs'
import classNames from 'classnames'

type CDKCol = {
  subscriptionId: string
  orgName: string
  activationDate: string
  mappedEntry?: {
    label: string
    value: number
  }
  last_run: string
}

const columnHelper = createColumnHelper<CDKCol>()

export default function CDK(): JSX.Element {
  const columns = useMemo(
    () => [
      columnHelper.accessor('subscriptionId', {
        header: () => 'ID',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.accessor('orgName', {
        header: () => 'Dealership',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.display({
        id: 'mapped',
        header: () => 'Mapped To',
        cell: ({ row }) => {
          if (row.original.mappedEntry) {
            return (
              <Link
                to={`../../../dealerships/${row.original.mappedEntry.value}/edit`}
                className="text-primary-persian-blue font-bold">
                {row.original.mappedEntry.label}
              </Link>
            )
          }
        },
      }),
      columnHelper.accessor('last_run', {
        header: () => 'Last Run At',
        cell: (info) =>
          info.getValue() ? (
            <div className="flex flex-row w-full items-center justify-center gap-3">
              <div
                className={classNames('w-5 h-5 rounded-full', {
                  'bg-secondary-engineering-red':
                    dayjs().diff(dayjs(info.getValue()), 'days') > 7,
                  'bg-secondary-jonquil':
                    dayjs().diff(dayjs(info.getValue()), 'days') > 1 &&
                    dayjs().diff(dayjs(info.getValue()), 'days') < 7,
                  'bg-secondary-spanish-green':
                    dayjs().diff(dayjs(info.getValue()), 'days') <= 1,
                })}
              />
              <span>{dayjs(info.getValue()).format('YYYY-MM-DD HH:mm:ss')}</span>
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <span>N/A</span>
            </div>
          ),
        enableSorting: false,
      }),
      columnHelper.accessor('activationDate', {
        header: 'Activation Date',
        cell: ({ getValue }) => dayjs(getValue()).format('MMM DD, YYYY'),
        enableSorting: false,
      }),
    ],
    [],
  )

  return (
    <motion.div className="flex flex-col gap-2 pt-5">
      <Table columns={columns} filters={{}} fetchFn={useGetPaginatedCDKDealerships} />
    </motion.div>
  )
}
